<script>
	import Dispatch from '../Dispatcher'
	import { faLockAlt, faWallet, faHandHoldingUsd, faPlay, faStop, faSolarSystem, faFire, faSparkles } from '@fortawesome/pro-solid-svg-icons'
	import { faSmile } from '@fortawesome/pro-regular-svg-icons'
	import Fa from 'svelte-fa'
  import { map, tap, withLatestFrom, startWith } from 'rxjs/operators';
  import _ from 'lodash'
  import { render } from '../engines/renderer'

export let index

  const renderer = render
    .pipe(
      startWith([]),
    )

  const show = renderer
    .pipe(
      map(e => _.find(e, dot => dot.id === index))
    )

  export let size

</script>

  <div class=' flex justify-center items-center' style={'height: ' + size + 'px; width: ' + size + 'px;'}>
    <div class={'white flex items-center justify-center' + ($show?.on ? ' bg-green br-100 ' : ' ') } style={'height: ' + size/2 + 'px; width: ' + size/2 + 'px; font-size: ' + size/10 + 'px'}>{$show ? '•' : '' }</div>
  </div>

<style>
</style>